

import React, { useState, useEffect } from "react";
import axios from "axios";
import {  useNavigate, useSearchParams } from "react-router-dom";
import { PiSpotifyLogoLight } from "react-icons/pi";
import PlaylistComp from "./PlaylistComp";
import { setPlaylistFlask } from "../Api/Flask/userapis";
import { useDispatch, useSelector } from "react-redux";
import GifLoader from "../Responsive/Components/GifLoader";
const SpotifyPlaylistPage = () => {
  const dispatch=useDispatch();
  // const token = useSelector((state) => state.SpotifyData).token;
  let token=localStorage.getItem('token')
  const [playlist, setplaylist] = useState();
  const [selectedPlaylistId, setSelectedPlaylistId] = useState(null);
  const [searchkey,setserchkey]=useState('');
  const [filterPlaylist,setfilterPlaylist]=useState([]);
  const [loader,setloader]=useState(false);
  const navigate = useNavigate();
  let [searchParams, setSearchParams] = useSearchParams();
  const paramIDS = searchParams.get("u");
  const [author, id] = paramIDS.split("--i=");
  
  const uploadPlaylist = async () => {
    try {
      setloader(true)
      let item = playlist.filter((ele) => ele.id === selectedPlaylistId);
      let uid = localStorage.getItem("uid");
      const link = item[0].external_urls.spotify;
      console.log(link,author)
      let res = await setPlaylistFlask({
        uid: uid,
        playlistURL: link,
        authorUID: author,
        id: id,
        spotify_token: token,
      });
    
      if (res.status === 200) {
        navigate(-1);
      } else {
        alert("try again");
      }
      setloader(false)
    } catch (error) {
      console.log('error')
    }
 
  };

  const GetPlayListData = async () => {
    try {
      console.log(token);
      const PLAYLISTS_ENDPOINT = "https://api.spotify.com/v1/me/playlists";
      const { data } = await axios.get(PLAYLISTS_ENDPOINT, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });
      setplaylist(data.items);
      setfilterPlaylist(data.item)
      console.log(data);
    } catch (error) {
      console.log(error);
      
    }
  };
useEffect(()=>{
  GetPlayListData();
},[])

const handleSerach=(e)=>{
  e.preventDefault();
  const key=searchkey.toLowerCase();
  if(playlist){
    const filteredItems = playlist.filter((item) =>
    item.name.toLowerCase().includes(key)
  );
   setfilterPlaylist(filteredItems)
  }else{
    console.log("no playlist")
  }
 
}
  return (
    <>
    
   { loader? <GifLoader />:
    <div className="flex flex-col justify-between h-[90vh]">
      <div>
        <form  className="my-3 mx-3" onSubmit={handleSerach}>
          <label
          
            class="mb-2 text-sm font-medium text-gray-900 sr-only  dark:text-white"
          >
            Search
          </label>
          <div class="relative">
            <div class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
              <svg
                class="w-4 h-4 text-gray-500 dark:text-gray-400"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 20 20"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                />
              </svg>
            </div>
            <input
              type="search"
              id="default-search"
              className="block w-full p-4 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="Search Mockups, Logos..."
              onChange={(e)=>{setserchkey(e.target.value)}}
             
            />
            <button
              type="submit"
              class="text-white absolute end-2.5 bottom-2.5 bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
            >
              Search
            </button>
          </div>
        </form>
        {  (
          (token && filterPlaylist) &&
          filterPlaylist.map((ele) => {
            return (
              <PlaylistComp
                key={ele.id}
                item={ele}
                isSelected={ele.id === selectedPlaylistId}
                onSelect={(id) => setSelectedPlaylistId(id)}
              />
            );
          })
        )}
      </div>

      {selectedPlaylistId && (
        <button
          onClick={uploadPlaylist}
          className="bg-[#333387] text-white p-4 rounded mx-3"
        >
          Upload your music taste
        </button>
      )}
    </div>}
    </>
  );
};

export default SpotifyPlaylistPage;

// uid XOTmjuhlG7VwQfwW8mp3FJAP6iu1
//  playlisturl https://open.spotify.com/playlist/2VzmO3vVovbI2VonHW6kj4
//   authoruid undefined
//    id -NlS9E57ho3PepjNAUW7
//    BQBrumMkhOGg7HwKIi0heZnz2uU9AazMr93CEx4hc3d179qiUOXCzTynT2PSXsdQUZcf2lfeXJkAj2dICzNdVHWDwmlfibIHGN4h-w7otB5jaTC0xVY0dT9gZWQGA13pl24dDQ3q3KDw0aKbCsbPS97kLJdKCf1Kuy3GoHJ6Z_hzLCox6sVvjZQ17M0YoxkfOeZKUE8stquDn8nB0iPwU_zPk3kjprsT--LHAWNnOUhu6mnZIVNzahovWv2Ap67YdKqPTfO6WCuSkj_cgcvtwuTDHXGATL288S4Rhm_aS5O5vA


